import {
	IconAward,
	IconBolt,
	IconBook2,
	IconBriefcase,
	IconBuildingStore,
	IconBulb,
	IconCalendar,
	IconCalendarEvent,
	IconCamera,
	IconCertificate,
	IconChartBar,
	IconChartLine,
	IconChartPie,
	IconCheck,
	IconChecklist,
	IconCircleCheck,
	IconClock,
	IconCloud,
	IconCode,
	IconCoin,
	IconCompass,
	IconConfetti,
	IconCreditCard,
	IconDeviceDesktop,
	IconDiamond,
	IconDownload,
	IconFile,
	IconFlag,
	IconFlame,
	IconGift,
	IconHeadphones,
	IconHeart,
	IconHelpCircle,
	IconHome,
	IconKey,
	IconLanguage,
	IconLeaf,
	IconLock,
	IconMail,
	IconMapPin,
	IconMessageCircle,
	IconMicrophone,
	IconPackage,
	IconPalette,
	IconPhone,
	IconPhoto,
	IconPlant,
	IconPlayerPlay,
	IconPuzzle,
	IconReceipt,
	IconRocket,
	IconSchool,
	IconSearch,
	IconSend,
	IconSettings,
	IconShieldCheck,
	IconShoppingBag,
	IconSparkles,
	IconSpeakerphone,
	IconStar,
	IconTarget,
	IconThumbUp,
	IconTools,
	IconTrendingUp,
	IconTrophy,
	IconTruck,
	IconUser,
	IconUsers,
	IconVideo,
	IconWallet,
	IconWand,
	IconWorld,
	type TablerIcon,
} from "@tabler/icons-react"
import { type FC } from "react"

import { getLandingFeatureIconDefinition, type LandingFeatureIconId } from "@forento/core/models/landingFeatureIcon"

const landingFeatureIconComponents: Record<LandingFeatureIconId, TablerIcon> = {
	award: IconAward,
	bolt: IconBolt,
	book: IconBook2,
	briefcase: IconBriefcase,
	store: IconBuildingStore,
	idea: IconBulb,
	calendar: IconCalendar,
	event: IconCalendarEvent,
	camera: IconCamera,
	certificate: IconCertificate,
	"bar-chart": IconChartBar,
	"line-chart": IconChartLine,
	"pie-chart": IconChartPie,
	check: IconCheck,
	checklist: IconChecklist,
	verified: IconCircleCheck,
	clock: IconClock,
	cloud: IconCloud,
	code: IconCode,
	coin: IconCoin,
	compass: IconCompass,
	celebration: IconConfetti,
	"credit-card": IconCreditCard,
	desktop: IconDeviceDesktop,
	diamond: IconDiamond,
	download: IconDownload,
	file: IconFile,
	flag: IconFlag,
	flame: IconFlame,
	gift: IconGift,
	headphones: IconHeadphones,
	heart: IconHeart,
	help: IconHelpCircle,
	home: IconHome,
	key: IconKey,
	language: IconLanguage,
	leaf: IconLeaf,
	lock: IconLock,
	mail: IconMail,
	location: IconMapPin,
	message: IconMessageCircle,
	microphone: IconMicrophone,
	package: IconPackage,
	palette: IconPalette,
	phone: IconPhone,
	photo: IconPhoto,
	plant: IconPlant,
	play: IconPlayerPlay,
	puzzle: IconPuzzle,
	receipt: IconReceipt,
	rocket: IconRocket,
	school: IconSchool,
	search: IconSearch,
	send: IconSend,
	settings: IconSettings,
	shield: IconShieldCheck,
	"shopping-bag": IconShoppingBag,
	sparkles: IconSparkles,
	speaker: IconSpeakerphone,
	star: IconStar,
	target: IconTarget,
	"thumb-up": IconThumbUp,
	tools: IconTools,
	growth: IconTrendingUp,
	trophy: IconTrophy,
	delivery: IconTruck,
	user: IconUser,
	users: IconUsers,
	video: IconVideo,
	wallet: IconWallet,
	wand: IconWand,
	world: IconWorld,
}

type Props = { value: string; className?: string }
const LandingFeatureIcon: FC<Props> = ({ value, className }) => {
	const definition = getLandingFeatureIconDefinition(value)
	if (definition === undefined) return null

	const Icon = landingFeatureIconComponents[definition.id]
	return <Icon aria-hidden="true" className={className} strokeWidth={1.8} />
}

export default LandingFeatureIcon
